<script setup lang="ts">
const localePath = useLocalePath();
</script>

<template>
  <div class="page-container">
    <div class="flex flex-col gap-4 p-4 site-viewport-container">
      <h1 class="text-xl font-semibold md:text-2xl">
        {{ $t("notFound.title") }}
      </h1>
      <h2>{{ $t("notFound.subtitle") }}</h2>
      <p>{{ $t("notFound.body") }}</p>
      <ul class="list-disc ml-4">
        <li>
          <NuxtLink
            class="underline"
            :to="localePath('/')"
          >
            {{ $t("pages.home") }}
          </NuxtLink>
        </li>
        <li>
          <BaseCustomerSupportLink class="underline">
            {{ $t("pages.support") }}
          </BaseCustomerSupportLink>
        </li>
      </ul>
    </div>
  </div>
</template>
